<template>
  <div
    class="col-sm-12 p-0 m-0 mx-auto index-root app-shell"
    :class="{
      'app-shell--game': $route.path === '/iframeURL',
      'app-shell--home': $route.path === '/' || $route.path === '/home',
      'col-lg-4': $route.path !== '/iframeURL',
    }"
  >
    <NavBar v-if="
      !$route.path.includes('rule') &&
      $route.path !== '/home' &&
      $route.path !== '/' &&
      $route.path !== '/auth/login' &&
      $route.path !== '/auth/register' &&
      $route.path !== '/iframeURL'
    " />
    <router-view
      :class="[
        $route.path.includes('login') ? '' : 'middle-container',
        'index-scroll-main',
      ]"
      class="position-relative"
    ></router-view>
    <Footer
      v-if="
        !$route.path.includes('rule') &&
        !$route.path.includes('live-score') &&
        !$route.path.includes('football-result') &&
        $route.path !== '/iframeURL' &&
        $route.path !== '/auth/login' &&
        $route.path !== '/auth/register'
      "
    />
    <!-- <div class="social-contacts" id="social-contacts">
            <div
                style="position: relative"
                class="cart-container"
                v-if="
                    $route.path.includes('maung-fb') ||
                    $route.path.includes('body-fb')
                "
                @click="openModalVoucher()"
            >
                <div>
                    <i class="ni ni-cart mb-2"></i>
                </div>
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('2d')"
                    >{{ this.$store.state.twod_slip_data.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('fb')"
                    >{{ this.$store.state.fb_order.fb_matches.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-else-if="$route.path.includes('3d')"
                    >{{ this.$store.state.threed_slip_data.length }}</span
                >
            </div>
        </div> -->

    <van-overlay :show="$store.state.isLoading">
      <div
        class="wrapper d-flex h-100vh"
        style="background: rgba(0, 0, 0, 0.8);"
      >
        <div class="loader my-auto mx-auto">

        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="showPopup"
      @click="showPopup = false"
      class="welcome-overlay"
    >
      <div
        class="wrapper col-lg-4 col-md-12 mx-auto d-flex h-100vh"
        @click.stop
      >
        <div class="welcome-popup mx-auto my-auto pt-4 px-4 pb-4">
          <!-- <img v-for="(welcome, index) in websiteInfo.welcome_banners" :key="index" :src="'https://yy24gld.sgp1.cdn.digitaloceanspaces.com/luckywin/banners/' + welcome.url" class="mx-auto my-auto" alt="" style="width: 100%; border-radius: 5px;"> -->
          <b-carousel
            id="carousel-1"
            :interval="3000"
            controls
            fade
            style="width: 100%; height: 100%"
          >
            <b-carousel-slide
              img-src="/assets/welcome-1.webp"></b-carousel-slide>
            <b-carousel-slide
              img-src="/assets/welcome-2.webp"></b-carousel-slide>
          </b-carousel>

          <!-- <video style="border-radius: 5px;" class="d-flex" width="100%" height="auto" autoplay loop muted>
                  <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0512ca93-7a5f-40cd-a989-8f5f3b21a600/public" type="video/mp4" />
                  Your browser does not support the video tag.
                </video> -->



          <div class="mt-3 d-flex flex-column">
            <div class="mx-auto mb-3">
              <div class="d-flex">
                <input
                  type="checkbox"
                  v-model="isHideForToday"
                  class="mb-1 mr-2 p-0 m-0"
                />
                <h3 class="text-white text-center p-0 m-0">Hide For Today</h3>
              </div>
            </div>

            <button
              class="btn btn-primary btn-block w-25 mx-auto text-uppercase welcome-popup__close"
              @click="closePopup()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </van-overlay>


    <div class="contact-float">
      <div
        class="wave"
        style="position: relative"
      >
        <span class="contact-ripple" aria-hidden="true"></span>
        <span class="contact-ripple contact-ripple--delay" aria-hidden="true"></span>
        <div
          class="contact"
          @click="showContact = !showContact"
        >
          <img
            src="https://storage.googleapis.com/spacetech2/general/headphones.png"
            alt=""
          />
        </div>
        <div
          class="contacts-container"
          :class="{ show: showContact }"
        >
          <div style="display: flex; flex-direction: column; gap: 10px">
            <a
              href="https://t.me/Shwekyarphyu168_Bot"
              target="_blank"
            >
              <img
                style="width: 3.5rem; height: 3.5rem"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_telegram.png"
                alt=""
              />
            </a>
            <a href="https://msng.link/o?959677640761=vi">
              <!-- <a href="#"> -->
              <img
                style="width: 3.5rem; height: 3.5rem;"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_viber.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div>
      <FloatIcon />
    </div> -->

    <van-overlay :show="isLuckyWheel">
      <div
        class="wrapper col-8"
        @click.stop
      >
        <LuckyWheel />
      </div>
    </van-overlay>

    <audio
      ref="bgMusic"
      src="/assets/music/shwekyarphyu.mp3"
      loop
      preload="auto"
      playsinline
    ></audio>

    <button
      v-if="$route.path !== '/iframeURL'"
      type="button"
      class="site-music-toggle"
      :class="{
        'is-playing': isMusicPlaying,
        'is-muted': !isMusicPlaying,
        'is-dragging': musicDragging,
      }"
      :style="musicButtonStyle"
      :aria-label="isMusicPlaying ? 'Mute music' : 'Play music'"
      :title="isMusicPlaying ? 'Stop music' : 'Play music'"
      @pointerdown="onMusicPointerDown"
      @click="onMusicClick"
    >
      <span class="site-music-toggle__icon">
        <i class="fas fa-music"></i>
        <span
          v-if="!isMusicPlaying"
          class="site-music-toggle__slash"
          aria-hidden="true"
        ></span>
      </span>
    </button>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import LuckyWheel from '../frontend/components/LuckyWheel.vue';

export default {
  components: {
    LuckyWheel,
  },
  data() {
    return {
      isLuckyWheel: false,
      isHideForToday: false,
      showPopup: false,
      websiteInfo: {},
      popUpLink: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/2025-03-07%205.36.20%E2%80%AFPM.jpg',
      showContact: false,
      interval: null,
      isMusicPlaying: false,
      musicEnabled: true,
      musicDragging: false,
      musicDragMoved: false,
      musicPos: { x: null, y: null },
      _musicUnlockBound: null,
      _musicDragBound: null,
      _musicDragEndBound: null,
      _musicDragOffset: { x: 0, y: 0 },
    };
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    this.checkPopupStatus();
    await this.fetchWebsiteData();
    this.initBackgroundMusic();
    this.loadMusicButtonPosition();
    // this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    this.teardownBackgroundMusic();
    this.endMusicDrag();
  },
  watch: {
    '$route.path'(path) {
      if (path === '/iframeURL') {
        this.pauseBackgroundMusic();
      } else if (this.musicEnabled) {
        this.tryPlayBackgroundMusic();
      }
    },
  },
  computed: {
    ...mapGetters(['getFBOrder']),
    musicButtonStyle() {
      if (this.musicPos.x == null || this.musicPos.y == null) {
        return {};
      }
      return {
        left: `${this.musicPos.x}px`,
        top: `${this.musicPos.y}px`,
        right: 'auto',
        bottom: 'auto',
      };
    },
  },

  methods: {
    loadMusicButtonPosition() {
      try {
        const raw = localStorage.getItem('skp_music_btn_pos_v2');
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (
          typeof parsed.x === 'number' &&
          typeof parsed.y === 'number' &&
          Number.isFinite(parsed.x) &&
          Number.isFinite(parsed.y)
        ) {
          this.musicPos = this.clampMusicPosition(parsed.x, parsed.y);
        }
      } catch (e) {
        /* ignore */
      }
    },
    saveMusicButtonPosition() {
      if (this.musicPos.x == null || this.musicPos.y == null) return;
      try {
        localStorage.setItem(
          'skp_music_btn_pos_v2',
          JSON.stringify({ x: this.musicPos.x, y: this.musicPos.y })
        );
      } catch (e) {
        /* ignore */
      }
    },
    clampMusicPosition(x, y) {
      const root = this.$el;
      const size = 54;
      const maxX = Math.max(0, (root ? root.clientWidth : window.innerWidth) - size);
      const maxY = Math.max(0, (root ? root.clientHeight : window.innerHeight) - size);
      return {
        x: Math.min(Math.max(0, x), maxX),
        y: Math.min(Math.max(0, y), maxY),
      };
    },
    onMusicPointerDown(event) {
      if (event.button != null && event.button !== 0) return;
      const root = this.$el;
      if (!root) return;

      const rootRect = root.getBoundingClientRect();
      const btnRect = event.currentTarget.getBoundingClientRect();
      const currentX = this.musicPos.x != null ? this.musicPos.x : btnRect.left - rootRect.left;
      const currentY = this.musicPos.y != null ? this.musicPos.y : btnRect.top - rootRect.top;

      this.musicPos = { x: currentX, y: currentY };
      this.musicDragging = true;
      this.musicDragMoved = false;
      this._musicDragOffset = {
        x: event.clientX - rootRect.left - currentX,
        y: event.clientY - rootRect.top - currentY,
      };

      if (event.currentTarget.setPointerCapture) {
        try {
          event.currentTarget.setPointerCapture(event.pointerId);
        } catch (e) {
          /* ignore */
        }
      }

      this._musicDragBound = (e) => this.onMusicPointerMove(e);
      this._musicDragEndBound = (e) => this.onMusicPointerUp(e);
      window.addEventListener('pointermove', this._musicDragBound, { passive: false });
      window.addEventListener('pointerup', this._musicDragEndBound);
      window.addEventListener('pointercancel', this._musicDragEndBound);
    },
    onMusicPointerMove(event) {
      if (!this.musicDragging) return;
      event.preventDefault();
      const root = this.$el;
      if (!root) return;
      const rootRect = root.getBoundingClientRect();
      const nextX = event.clientX - rootRect.left - this._musicDragOffset.x;
      const nextY = event.clientY - rootRect.top - this._musicDragOffset.y;
      const clamped = this.clampMusicPosition(nextX, nextY);
      if (
        Math.abs(clamped.x - this.musicPos.x) > 2 ||
        Math.abs(clamped.y - this.musicPos.y) > 2
      ) {
        this.musicDragMoved = true;
      }
      this.musicPos = clamped;
    },
    onMusicPointerUp() {
      if (!this.musicDragging) return;
      this.endMusicDrag();
      if (this.musicDragMoved) {
        this.saveMusicButtonPosition();
      }
    },
    endMusicDrag() {
      this.musicDragging = false;
      if (this._musicDragBound) {
        window.removeEventListener('pointermove', this._musicDragBound);
        this._musicDragBound = null;
      }
      if (this._musicDragEndBound) {
        window.removeEventListener('pointerup', this._musicDragEndBound);
        window.removeEventListener('pointercancel', this._musicDragEndBound);
        this._musicDragEndBound = null;
      }
    },
    onMusicClick(event) {
      if (this.musicDragMoved) {
        event.preventDefault();
        event.stopPropagation();
        this.musicDragMoved = false;
        return;
      }
      this.toggleMusic();
    },
    initBackgroundMusic() {
      try {
        this.musicEnabled = localStorage.getItem('skp_music_enabled') !== '0';
      } catch (e) {
        this.musicEnabled = true;
      }

      const audio = this.$refs.bgMusic;
      if (!audio) return;
      audio.volume = 0.45;
      audio.loop = true;

      if (this.musicEnabled && this.$route.path !== '/iframeURL') {
        this.tryPlayBackgroundMusic();
        this.bindMusicUnlock();
      }
    },
    bindMusicUnlock() {
      if (this._musicUnlockBound) return;
      this._musicUnlockBound = () => {
        if (this.musicEnabled && !this.isMusicPlaying) {
          this.tryPlayBackgroundMusic();
        }
        this.unbindMusicUnlock();
      };
      window.addEventListener('pointerdown', this._musicUnlockBound, { once: true, passive: true });
      window.addEventListener('keydown', this._musicUnlockBound, { once: true });
    },
    unbindMusicUnlock() {
      if (!this._musicUnlockBound) return;
      window.removeEventListener('pointerdown', this._musicUnlockBound);
      window.removeEventListener('keydown', this._musicUnlockBound);
      this._musicUnlockBound = null;
    },
    async tryPlayBackgroundMusic() {
      const audio = this.$refs.bgMusic;
      if (!audio || !this.musicEnabled || this.$route.path === '/iframeURL') return;
      try {
        await audio.play();
        this.isMusicPlaying = true;
      } catch (e) {
        this.isMusicPlaying = false;
        this.bindMusicUnlock();
      }
    },
    pauseBackgroundMusic() {
      const audio = this.$refs.bgMusic;
      if (!audio) return;
      audio.pause();
      this.isMusicPlaying = false;
    },
    toggleMusic() {
      this.musicEnabled = !this.musicEnabled;
      try {
        localStorage.setItem('skp_music_enabled', this.musicEnabled ? '1' : '0');
      } catch (e) {
        /* ignore */
      }

      if (this.musicEnabled) {
        this.tryPlayBackgroundMusic();
      } else {
        this.pauseBackgroundMusic();
        this.unbindMusicUnlock();
      }
    },
    teardownBackgroundMusic() {
      this.unbindMusicUnlock();
      this.pauseBackgroundMusic();
    },
    testing() {
      this.isLuckyWheel = true;
      console.log('testing');
    },
    closePopup() {
      this.showPopup = false;
      const today = new Date().toISOString().split('T')[0];
      if (this.isHideForToday)
        localStorage.setItem('popupDismissedDate', today);
    },
    checkPopupStatus() {
      const today = new Date().toISOString().split('T')[0];
      const lastDismissedDate = localStorage.getItem('popupDismissedDate');
      if (lastDismissedDate !== today) {
        this.showPopup = true;
      }
      // if(today === '2025-02-07'){
      //   this.popUpLink = 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/2025-02-07%208.13.41%E2%80%AFPM.jpg';
      // } else {
      //   this.popUpLink = 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/welcome.jpg'
      // }
    },

    ...mapMutations(['setWholeFBMatches', 'setContactInfo', 'setContactTelegram']),
    ...mapActions(['fetchUser']),
    closeModalOutside(event) {
      if (event.target.classList.contains('modal')) {
        this.$router.go();
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
        this.setContactInfo(this.websiteInfo.contact_info);
        this.setContactTelegram(
          this.websiteInfo.telegram_info
            || this.websiteInfo.contact_telegram
            || this.websiteInfo.telegram
            || this.websiteInfo.telegram_link
            || null
        );
        if (
          res.data.data[0].androidVersion !== this.$store.state.androidVersion
        ) {
          $('#version').modal('show');
        }
      } catch (error) {
        console.log(error);
      }
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError =
          this.$store.state.language === 'en'
            ? 'Please select some teams!'
            : 'အသင်းတစ်ချို့ ရွေးပေးပါ။';
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        if (!this.$store.state.betAmount) {
          $('#amount').modal('show');
        } else {
          for (let i = 0; i < matches.length; i += 1) {
            matches[i].bet_amount = this.$store.state.betAmount;
          }
          this.setWholeFBMatches(matches);
          $('#mobile-voucher').modal('show');
        }
      }
    },

    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === 'en'
            ? 'Go Back'
            : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
  },
};
</script>
<style scoped>
.hello-world {
  background-image: linear-gradient(0deg,
      #fec8ba,
      #fedcd0 35%,
      #fef0e6) !important;
}


/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border: 4px solid #0000;
  border-radius: 50%;
  border-color: #ccc #0000;
  animation: l16 1s infinite linear;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
}

.loader::before {
  border-color: #f03355 #0000;
  animation: inherit;
  animation-duration: .5s;
  animation-direction: reverse;
}

.loader::after {
  margin: 8px;
}

@keyframes l16 {
  100% {
    transform: rotate(1turn)
  }
}


.active-contact {
  transform: translate(0);
  transition: all 1s ease-in-out;
}

.box-contact .open-contact {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -12px;
  margin: auto;
}

.box-contact a img {
  width: 40px;
}

.box-contact {
  position: fixed;
  top: 60%;
  right: 0;
  border-radius: 12px 0 0 12px !important;
  background: linear-gradient(180deg,
      rgba(62, 62, 62, 0.5411764706) 0%,
      rgba(10, 10, 10, 0.5725490196) 100%);
  padding: 1rem 0.5rem 1rem 1.3rem;
  transform: translate(0);
  animation: slide 2s ease-in;
  z-index: 10;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.4) !important;
}

.floating {
  position: fixed;
  width: 90px;
  z-index: 1;
  animation: floating 20s infinite;
  bottom: 130px;
  right: 0%;
}

#closeButton {
  border: none;
  background: none;
  position: absolute;
  left: -15px;
  font-size: 20px;
  font-weight: bold;
  color: #b7b7b7;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-20px);
  }

  100% {
    transform: translatey(0px);
  }
}

.cart-number {
  top: -2px !important;
  left: -2px !important;
}

.cart-number {
  position: absolute;
  top: -3px;
  left: -3px;
  text-align: center;
}

.site-music-toggle {
  /* Default: right side of home notice bar (below navbar ~54px) */
  position: absolute;
  top: 3.55rem;
  right: 0.4rem;
  left: auto;
  bottom: auto;
  z-index: 1100;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.4rem;
  height: 3.4rem;
  border: 2px solid rgba(255, 214, 64, 0.35);
  border-radius: 50%;
  background: linear-gradient(145deg, #2a220f 0%, #15110a 100%);
  color: #c4b06a;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
  cursor: grab;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  transition: box-shadow 0.25s ease, transform 0.2s ease, background 0.25s ease, color 0.25s ease;
}

.site-music-toggle.is-muted {
  color: #8a7d52;
  border-color: rgba(180, 160, 80, 0.4);
  background: linear-gradient(145deg, #1c1810 0%, #0f0d09 100%);
}

.site-music-toggle.is-playing {
  color: #1a1400;
  background: linear-gradient(135deg, #fff59d 0%, #ffd000 45%, #f5b800 100%);
  border-color: #fff3a0;
  box-shadow:
    0 0 0 0 rgba(255, 208, 0, 0.45),
    0 6px 18px rgba(255, 208, 0, 0.45);
  animation: music-alive 2.2s ease-in-out infinite;
}

.site-music-toggle.is-playing::before,
.site-music-toggle.is-playing::after {
  position: absolute;
  inset: -5px;
  border: 1.5px solid rgba(255, 220, 80, 0.55);
  border-radius: 50%;
  content: "";
  animation: music-ring 1.8s ease-out infinite;
  pointer-events: none;
}

.site-music-toggle.is-playing::after {
  animation-delay: 0.9s;
}

.site-music-toggle.is-dragging {
  cursor: grabbing;
  transform: scale(1.06);
  animation: none;
  box-shadow: 0 10px 24px rgba(255, 208, 0, 0.35);
}

.site-music-toggle__icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  pointer-events: none;
}

.site-music-toggle i {
  font-size: 1.25rem;
  line-height: 1;
  pointer-events: none;
}

.site-music-toggle.is-muted i {
  opacity: 0.72;
}

.site-music-toggle__slash {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.55rem;
  height: 0.16rem;
  border-radius: 999px;
  background: #ff5a5a;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
  transform: translate(-50%, -50%) rotate(-40deg);
}

@keyframes music-alive {
  0%,
  100% {
    box-shadow: 0 0 10px rgba(255, 208, 0, 0.35), 0 6px 18px rgba(255, 208, 0, 0.4);
  }

  50% {
    box-shadow: 0 0 22px rgba(255, 208, 0, 0.7), 0 8px 22px rgba(255, 208, 0, 0.55);
  }
}

@keyframes music-ring {
  0% {
    opacity: 0.7;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1.55);
  }
}

/* Welcome popup entrance */
.welcome-popup {
  background: rgba(6, 17, 11, 0.92);
  border: 1px solid rgba(0, 242, 61, 0.35);
  border-radius: 12px;
  box-shadow:
    0 0 0 1px rgba(0, 168, 45, 0.15),
    0 18px 48px rgba(0, 0, 0, 0.55),
    0 0 40px rgba(0, 242, 61, 0.12);
  animation: welcome-pop-in 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.welcome-popup__close {
  background: linear-gradient(135deg, #06110b 0%, #0d5c2e 50%, #00a82d 100%) !important;
  border: 1px solid rgba(67, 255, 116, 0.45) !important;
  box-shadow: 0 0 16px rgba(0, 242, 61, 0.35);
  animation: welcome-cta-glow 2.4s ease-in-out infinite;
}

@keyframes welcome-pop-in {
  from {
    opacity: 0;
    transform: scale(0.88) translateY(12px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes welcome-cta-glow {
  0%,
  100% {
    box-shadow: 0 0 12px rgba(0, 242, 61, 0.28);
  }

  50% {
    box-shadow: 0 0 22px rgba(0, 242, 61, 0.55);
  }
}

/* Flex shell: scroll lives here so content works with html/body overflow:hidden */
.index-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  max-width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
  position: relative;
  overflow: hidden;
  background: #06110b;
}

/* PC: keep mobile layout centered like a phone frame */
@media (min-width: 768px) {
  .index-root:not(.app-shell--game) {
    max-width: 520px;
    width: 100%;
    border-left: 1px solid rgba(0, 242, 61, 0.16);
    border-right: 1px solid rgba(0, 242, 61, 0.16);
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.35),
      0 18px 60px rgba(0, 0, 0, 0.55);
  }
}

/* .index-scroll-main + .middle-container: global rules in src/scss/style.scss (scoped CSS here does not apply to router-view child roots) */
@media (max-width: 768px) {
  .cart-container {
    font-size: 30px !important;
  }

  .social-contacts div {
    width: 60px !important;
    height: 60px !important;
    margin-top: 15px;
  }

  #social-contacts .badge-circle.badge-md {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .cart-container {
    visibility: visible;
    font-size: 16px;
  }
}

.contact-float {
  position: fixed;
  bottom: 70px;
  right: 10px;
  z-index: 1050;
}

.contacts-container {
  position: absolute;
  bottom: 110%;
  left: 25%;
  opacity: 0;
  pointer-events: none;
  transform: translateY(20px) translateX(-25%);
  transition: opacity 0.28s ease, transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

.contacts-container.show {
  opacity: 1;
  pointer-events: all;
  transform: translateX(-25%) translateY(-10px);
}

.contacts-container.show a {
  display: inline-block;
  animation: contact-link-pop 0.35s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.contacts-container.show a:nth-child(2) {
  animation-delay: 0.07s;
}

.contact {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fffce0 0%, #f9f38d 30%, #d6b800 60%, #fff2a8 100%);
  box-shadow: 0 6px 18px rgba(214, 184, 0, 0.4);
  cursor: pointer;
  animation: contact-bob 2.6s ease-in-out infinite;
}

.contact img {
  width: 40px;
  height: 40px;
  pointer-events: none;
}

.contact-ripple {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  margin: -30px 0 0 -30px;
  border: 2px solid rgba(255, 220, 80, 0.55);
  border-radius: 50%;
  animation: contact-ripple 2.4s ease-out infinite;
  pointer-events: none;
}

.contact-ripple--delay {
  animation-delay: 1.2s;
}

@keyframes contact-bob {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }

  50% {
    transform: translateY(-4px) scale(1.04);
  }
}

@keyframes contact-ripple {
  0% {
    opacity: 0.65;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1.75);
  }
}

@keyframes contact-link-pop {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.85);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .welcome-popup,
  .welcome-popup__close,
  .site-music-toggle.is-playing,
  .site-music-toggle.is-playing::before,
  .site-music-toggle.is-playing::after,
  .contact,
  .contact-ripple,
  .contacts-container.show a {
    animation: none !important;
  }

  .contacts-container {
    transition: none !important;
  }
}
</style>
